export default __webpack_public_path__ + "static/media/mcsmith.c01f59c8.jpg";